import { useMutation } from '@apollo/client';

import AddContractNoteMutation from '@/graphql/contracts/addContractNote.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { AddContractNote, AddContractNoteVariables } from '@/graphql/contracts/_generated_/addContractNote.mutation';
import { notificationService } from '@/services/notification/notification.client';

export type AddNoteDto = AddContractNoteVariables;

export function useAddContractNote() {

  const [_addNote] = useMutation<AddContractNote, AddContractNoteVariables>(
    AddContractNoteMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const addNote = (dto: AddNoteDto, onSuccess?: () => void) => {
    _addNote({
      variables: dto,
      onCompleted: () => {
        notificationService.open({
          title: 'Add note',
          text: 'New note successfully added to contract',
          type: 'success',
        });

        onSuccess?.();
      },
    });
  };

  return {
    addNote
  } as const;
}
